import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './componentes/App';

class WebComponent extends HTMLElement {
	connectedCallback() {
		createRoot(this).render(<App />);
	}
}


const ELEMENT_ID = 'spain-transfers-buscador-ver3';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}
